export { Color, colors, StatusColor, statusColors } from './colors'
export type { FontsProps } from './fonts-settings'
export { fontsSettings } from './fonts-settings'
export { default as GlobalStyle } from './global-style'
export { Space, space } from './space'
export { theme } from './theme'
